

















































































// @ is an alias to /src
import apiFlux from "@/api/flux";
import { Component, Vue } from "vue-property-decorator";
import EditDrawer from "@/components/shared/EditDrawer.vue";
import deepEqual from "deep-equal";
import cloneDeep from "clone-deep";
import { directPayloadQuery } from "@/utils/api";
import {
  AloMercurial,
  getDefaultAloMercurial,
} from "@/models/alo/AloMercurial";
import { AloFlux, getDefaultAloFlux } from "@/models/alo/AloFlux";
import { toSubArray } from "@/utils/groupBy";
import { FlcMercurialScope } from "@/enum/FlcMercurialScope";

@Component({
  name: "EditMercurial",
  components: { EditDrawer },
})
export default class EditMercurial extends Vue {
  private original: string = "";
  private modified: string = "";
  private originalItems: Array<AloMercurial> = [];
  private showDrawer = false;
  private saving = false;
  private originalFlux = getDefaultAloFlux();
  private modifiedFlux = getDefaultAloFlux();
  get rows() {
    return this.doublonCodic ? 26 : 27;
  }

  edit(items: Array<AloMercurial>, flux: AloFlux) {
    this.originalFlux = flux;
    this.modifiedFlux = cloneDeep(flux);
    this.originalItems = items;
    this.original = items
      .map(
        (m) => `${m.mrcCodic}\t${m.mrcPxFinalHt.toString().replace(".", ",")}`
      )
      .join("\n");
    this.$store.myActions.ADM_FLUX_RESET_STATUS();
    this.showDrawer = true;
    this.modified = this.original;
  }

  get isDirty() {
    return (
      !deepEqual(this.original, this.modified) ||
      !deepEqual(this.originalFlux, this.modifiedFlux)
    );
  }

  created() {
    this.$store.myActions.CATALOGUE_TREE_ENSURE();
  }

  get mercurials() {
    const newMercurials = [] as Array<AloMercurial>;
    this.modified.split("\n").forEach((r) => {
      const mrcPart = r.split("\t");
      if (mrcPart.length > 1) {
        const prix = Number.parseFloat(mrcPart[1].replace(",", "."));
        if (!isNaN(prix)) {
          newMercurials.push({
            mrcCodic: mrcPart[0],
            mrcPxFinalHt: prix,
          });
        }
      }
    });
    return newMercurials;
  }

  get doublonCodic() {
    const doublon = {} as { [index: string]: boolean };
    for (var mercurial of this.mercurials) {
      if (doublon[mercurial.mrcCodic]) return mercurial.mrcCodic;
      doublon[mercurial.mrcCodic] = true;
    }
    return null;
  }

  saveData() {
    this.saving = true;

    const mercurialSaving = directPayloadQuery(
      apiFlux.saveMercurial,
      { id: this.modifiedFlux.id, mercurials: this.mercurials },
      this.$store
    );
    mercurialSaving.then((items) => {
      this.originalItems.splice(0, this.original.length, ...items);
    });

    const fluxSaving = this.$store.myActions.ADM_FLUX_SAVE_REQUEST(
      this.modifiedFlux
    );

    Promise.all([mercurialSaving, fluxSaving])
      .then(() => {
        this.$store.myActions.UI_ADD_SNACK_MESSAGE(this.fluxStatus);
        this.showDrawer = false;
      })
      .finally(() => {
        this.saving = false;
      });
  }

  get fluxStatus() {
    return this.$store.myGetters.fluxStatus;
  }

  get mercurialScope() {
    return this.modifiedFlux.flcMercurialScope &&
      this.modifiedFlux.flcMercurialScope.length > 0 &&
      this.modifiedFlux.flcMercurialScope != "Default"
      ? this.modifiedFlux.flcMercurialScope.split(", ")
      : [];
  }

  set mercurialScope(value: Array<string>) {
    this.modifiedFlux.flcMercurialScope =
      value.length > 0 ? value.join(", ") : "Default";
  }

  get mercurialMode() {
    return this.modifiedFlux.flcMercurialMode == "UseTac"
      ? "UseTac"
      : this.modifiedFlux.flcMercurialMode == "ForceMercurial"
      ? "ForceMercurial"
      : "Standard";
  }

  set mercurialMode(value: string) {
    this.modifiedFlux.flcMercurialMode = value;
  }
}
